export default __webpack_public_path__ + "static/media/smartobject_original.3743c8bf.png";